import { Controller } from "stimulus";
import MicroModal from "micromodal";
import { useDispatch } from "stimulus-use";
import cart from "util/cart.js";
import countryList from "./countries";
import { setCookie } from "init/cookie";
import { CheckoutStorageHandler } from "util/checkout_storage_handler";


export default class extends Controller {
  static targets = [
    "readMore",
    "readMoreSvg",
    "travelInsurance",
    "readMoreBlock",
    "insuranceFee",
    "feeBlock",
    "submitBtn",
    "promoCode",
    "address",
    "address2",
    "city",
    "state",
    "statesList",
    "country",
    "postalCode",
    "ccnum",
    "expiryInput",
    "cvv",
    "paymentErrorSpan",
    "form",
    "promocode",
    "expiry",
    "emailInput",
    "firstNameInput",
    "lastNameInput",
    "phoneInput",
    "paymentInput",
    "paymentCardInput",
    "paymentExpirationDateInput",
    "paymentCvvInput",
    "promoCodeInput",
    "errorPopupText",
    "statesContainer",
    "checkbox",
    "hiddenInput",
    "dropdownInfo",
    "dropdownBlock",
    "stateHidden",
    "countryHidden"
  ];

  connect() {
    useDispatch(this);

    MicroModal.init({
      disableScroll: true,
      onShow: modal => this.dispatch("opened", { modalID: modal.id })
    });
    this.validForm = false;
    this.scrolled = false;
    this.invalidFields = [];
    this.buildExpiryMask();
    setTimeout(() => {
      this.addressAutoComplete();
    }, 1000);

    this.setPersistedData();
  }

  openModal(e) {
    this.errorPopupTextTarget.textContent = e.detail;
    MicroModal.show('errorPopUp');
  }

  addressAutoComplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addressTarget,
      {
        fields: ["address_components"],
        types: ["address"]
      }
    );

    autocomplete.addListener("place_changed", () => {
      this.clearAutocomplete();
      const place = autocomplete.getPlace();
      this.setAutocompleteValues(place);
    });
  }

  setAutocompleteValues(place) {
    const data = {
      address: ""
    };
    
    const storageHandler = new CheckoutStorageHandler();
    const persistedData = storageHandler.getData();

    place.address_components.forEach(component => {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          data.address = `${component.long_name} ${data.address}`;
          break;
        }
        case "route": {
          data.address += component.long_name;
          break;
        }
        case "sublocality_level_1": {
          data.city = component.long_name;
          break;
        }
        case "postal_code": {
          data.postal = component.long_name;
          break;
        }
        case "locality": {
          data.city = component.long_name;
          break;
        }
        case "administrative_area_level_2": {
          if (data.city === undefined) {
            data.city = component.long_name;
          }
          break;
        }
        case "administrative_area_level_1": {
          data.state = component.short_name;
          persistedData['state'] = component.long_name;
          persistedData['hiddenState'] = component.short_name;
       
          this.stateTarget.textContent = component.long_name;
          break;
        }
        case "country": {
          data.country = component.short_name;
          persistedData['country'] = component.long_name;
          persistedData['hiddenCountry'] = component.short_name;
          this.updateStatesSelect(data.country.toUpperCase());
          break;
        }
        default: {
          break;
        }
      }
    });
  
    persistedData['contact[zip]'] = data.postal;
    persistedData['contact[city]'] = data.city;
    setCookie('country_code', data.country)

    const country = countryList.find(
      item => item.countryShortCode === data.country.toUpperCase()
    );
    this.countryTarget.value = country.countryName || "";

    const stateExist = country.regions.find(
      item => item.shortCode === data.state.toUpperCase()
    );
    this.stateTarget.value = stateExist ? stateExist.name : "";
    this.cityTarget.value = data.city || "";
    this.postalCodeTarget.value = data.postal || "";
    this.addressTarget.value = data.address || "";

    persistedData.address = this.addressTarget.value

    storageHandler.updateCookies(data.country);
    storageHandler.setData(persistedData);

    if (data.country) {
      this.dispatch("setSelectedCountry", { country: data.country });
    }
    if (data.state) {
      this.dispatch("setSelectedState", { state: data.state });
    }
   this.validateField(this.cityTarget, true)
   this.validateField(this.stateTarget, true)
   this.validateField(this.countryTarget, true)
   this.validateField(this.postalCodeTarget, true)
   this.validateField(this.addressTarget, true)
  }

  clearAutocomplete() {
    this.cityTarget.value = "";
    this.stateTarget.textContent = "";
    this.stateTarget.value = "";
    this.countryTarget.value = "";
    this.countryTarget.dispatchEvent(new Event("change"));
    this.postalCodeTarget.value = "";
  }

  countrychanged(event) {
    if (event.detail.target === "country") {
      this.validateField(this.countryTarget, true)
      this.updateStatesSelect(event.detail.value, event.detail.fromCache);
    } else if (event.detail.target === "state") {
      this.validateField(this.stateTarget, true)
    }
  }

  buildExpiryMask() {
    this.expiryTarget.addEventListener("keyup", this.maskexpiry.bind(this));
    this.expiryTarget.addEventListener("change", this.maskexpiry.bind(this));
  }

  maskexpiry(e) {
    const val = e.target.value;
    const formattted = val.replace(/.*?(\d).*(\d).*(\d).*(\d).*/g, "$1$2/$3$4");
    this.expiryTarget.value = formattted;
    e.target.value = formattted;
  }

  validate() {
    const requiredFields = this.formTarget.querySelectorAll("[required]");

    this.invalidFields = [];

    requiredFields.forEach(field => {
      this.validateField(field, false);
    });

    if (this.invalidFields.length === 0) {
      if (this.checkboxTarget.checked) {
        this.activateSubmitBtn();
      } else {
        this.scrollToRentalAgreement();
      }
    } else {
      this.deactivateSubmitBtn();
      this.focusError();
    }
  }


  validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return regex.test(email);
   }

  validateField(field, isSingle) {
    let parent = null;
    const { parentNode } = field;
    // check not only input fields but also selects
    if (parentNode.classList.contains("selected-option")) {
      parent = parentNode.parentNode;
    } else {
      parent = parentNode
    }

    let valueToCheck = field.value === undefined ? '' : field.value;
    if (valueToCheck === "") {
      // Check if there's a sibling hidden input and use its value if present
      const siblingHiddenInput = parent.querySelector('input[type="hidden"]');
      if (siblingHiddenInput) {
        valueToCheck = siblingHiddenInput.value === undefined ? '' : siblingHiddenInput.value;
      } 
    }

    const isEmailField = field === this.emailInputTarget;
    
      if (valueToCheck !== "") {
        if (isEmailField && !this.validateEmail(valueToCheck)) {
          // Invalid Email
          parent.classList.add("error-invalid");
          if (this.invalidFields) {
            if (!this.invalidFields.includes(field)) {
              this.invalidFields.push(field);
            }
            this.deactivateSubmitBtn();
            return;  // Exit function to prevent further processing
          }
          
        } 
        if (parent.classList.contains("error-invalid")) {
          parent.classList.remove("error-invalid");
        }
        
        // Valid Field
        parent.classList.remove("error");
        field.classList.remove("error-msg");
        field.placeholder = field.getAttribute("data-placeholder");
  
        if (field === this.checkboxTarget) {
          if (!field.checked) {
            this.checkboxTarget.classList.add("error")
            this.deactivateSubmitBtn();
          } else if (this.checkboxTarget.classList.contains("error")) {
            this.checkboxTarget.classList.remove("error");
          }
        }
       
        if (this.invalidFields.length !== 0) {
          this.invalidFields = this.invalidFields.filter(item => item !== field);
          if (this.invalidFields.length === 0 && isSingle) this.checkValidation();
          if (
            this.invalidFields.filter(item =>
              this.paymentInputTargets.find(target => target.contains(item))
            ).length === 0
          )
            this.paymentErrorSpanTarget.textContent = "";
        }
      } else {
        // Invalid Field
        if (parent.classList.contains("error-invalid")) {
          parent.classList.remove("error-invalid");
        }
        const msg = field.validationMessage;
        if (!this.invalidFields.includes(field)) {
          this.invalidFields.push(field);
        }
        if (!parent.querySelector(".error")) {
          const paymentInput = this.paymentInputTargets.find(target =>
            target.contains(field)
          );

          if (paymentInput) {
            const errorSpan = this.paymentErrorSpanTarget;
            const mesage =
              field.validationMessage === "Please fill out this field."
                ? "Please fill out the payment information"
                : field.validationMessage;
            errorSpan.textContent = mesage;
          } else if (field.placeholder === " ") {
            field.placeholder = msg;
          } else if (
            field.getAttribute("data-placeholder") !==
            "Please fill out this field."
          ) {
            if (parent.className !== "info-block error") {
              // check if fields already has a error
              if (field.placeholder && !field.placeholder.includes('Please fill')) {
                field.placeholder = msg;
              } 
            }
          }
          parent.classList.add("error");
        }
        this.deactivateSubmitBtn();
      }
  }

  checkValidation() {
    const requiredFields = this.formTarget.querySelectorAll("[required]");
    const invalidFields = [];

    requiredFields.forEach((field) => {
      if (
        (field.type === "text" && field.value === "") ||
        (field.type === "checkbox" && field.checked === false) || 
        (field.type === "text" && field === this.emailInputTarget && !this.validateEmail(field.value))
      ) {
        if (!this.invalidFields.includes(field)) {
          this.invalidFields.push(field);
        }
      }
    });

    if (invalidFields.length === 0) {
      if (this.checkboxTarget.checked) {
        this.activateSubmitBtn();
      } else {
       this.scrollToRentalAgreement();
      }
    }
  }

  activateSubmitBtn() {
    this.submitBtnTargets.forEach(target => target.classList.remove("disabled"));
  }

  deactivateSubmitBtn() {
    this.submitBtnTargets.forEach(target =>
      target.classList.add("disabled")
    );
  }

  popupError(message) {
    this.errorPopupTextTarget.textContent = message;
    MicroModal.show("errorPopUp");
  }

  popupClose() {
        // cart.clear();
    // const path = this.formTarget.dataset.resort
    // window.location.href = `/${path}/accommodations`
    MicroModal.close("errorPopUp");
  }

  showTravelInsuranceInfo(e) {
    e.preventDefault();

    this.readMoreTarget.classList.toggle("active");
    this.travelInsuranceTarget.classList.toggle("active");
    this.insuranceFeeTarget.classList.toggle("active");
    this.feeBlockTarget.classList.toggle("active");

    if (this.readMoreTarget.classList.contains("active")) {
      this.readMoreTarget.textContent = "Read less";
      this.dropdownInfoTarget.style.flexDirection = "column";
      this.readMoreSvgTarget.style.transform = "rotate(180deg)";
      this.dropdownBlockTarget.classList.add("opened");
    } else {
      this.readMoreSvgTarget.style.transform = "rotate(0deg)";
      this.readMoreTarget.textContent = "Read more";
      this.dropdownInfoTarget.style.flexDirection = "row";
      this.dropdownBlockTarget.classList.remove("opened");
    }
  }

  focusError() {
    const field = this.invalidFields[0];

    if (field) {
      field.focus();
      field.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  updateStatesSelect(countryCode, fromCache) {
    const listItems = this.statesContainerTarget.getElementsByClassName(
      "list-items"
    )[0];
    const country = countryList.find(
      item => item.countryShortCode === countryCode.toUpperCase()
    );

    if (country) {
      this.stateTarget.textContent = "";
      this.stateTarget.value = "";
      this.stateHiddenTarget.value = "";
      while (listItems.lastElementChild) {
        listItems.removeChild(listItems.lastElementChild);
      }
      country.regions.forEach(item => {
        const option = document.createElement("div");
        option.setAttribute("data-value", item.shortCode);
        option.textContent = item.name;
        option.setAttribute("data-action", "click->select-input#selectOption");
        option.setAttribute("required", true);
        option.setAttribute("data-name", "state");
        option.setAttribute(
          "data-target",
          `select-input.option select-input.state`
        );
        option.classList.add("dropdown-item");
        listItems.appendChild(option);
      });
      this.dispatch("initCustomScroll");
     
      if (!fromCache) {
        this.validateField(this.stateTarget, true)
      } else {
        this.setStateAndHiddenState();
      }
    }
  }

  blur(e) {
    const { name, value, required } = e.target;
    this.persist(name, value);
    if (required) {
      this.validateField(e.target, true);
    }
    this.checkValidation();
  }

  persist(name, value) {
    const storageHandler = new CheckoutStorageHandler();
    const persistedData = storageHandler.getData();
    persistedData[name] = value;
    storageHandler.setData(persistedData);
  }

  setPersistedData() {
    const pointers = {
      'contact[email]': this.emailInputTarget,
      'contact[first_name]': this.firstNameInputTarget,
      'contact[last_name]': this.lastNameInputTarget,
      'contact[phone]': this.phoneInputTarget,
      'payment[expiration_date]': this.paymentExpirationDateInputTarget,
      'payment[cvv]': this.paymentCvvInputTarget,
      'promo_code': this.promoCodeInputTarget,
      'contact[zip]': this.postalCodeTarget,
      'contact[city]': this.cityTarget,
      'contact[address2]': this.address2Target,
      'address': this.addressTarget
    };
    const storageHandler = new CheckoutStorageHandler();
    const persistedData = storageHandler.getData();

    if (!persistedData) return;
  
    Object.entries(persistedData).forEach(([name, value]) => {
      if (pointers[name]) pointers[name].value = value;
    });

    if (persistedData.curdNumber) {
      this.checkCardType(null, true);
    }

    storageHandler.setData(persistedData);
  }

  formatCardNumber() {
    const cardNumber = this.paymentInputTarget.value.replace(/\D/g, "");
    const formattedCardNumberArray = cardNumber.match(/.{1,4}/g);
    const formattedCardNumber = formattedCardNumberArray
      ? formattedCardNumberArray.join(" ")
      : cardNumber;
    this.paymentInputTarget.value = formattedCardNumber;
  }

  checkCardType(e, fromCache = false) {
    const storageHandler = new CheckoutStorageHandler();
    const persistedData = storageHandler.getData();

    const currentValue = fromCache ? persistedData.curdNumber : e.target.value;
    persistedData.curdNumber = currentValue;
    storageHandler.setData(persistedData);

    const number = currentValue.split(" ").join("");

    const cardTypes = [
      {
        name: "American Express",
        abbr: "am_ex",
        regex: /^(?:3[47][0-9]{13})$/
      },
      {
        name: "Visa",
        abbr: "visa",
        regex: /^(?:4[0-9]{12}(?:[0-9]{3})?)$/
      },
      {
        name: "Mastercard",
        abbr: "mastercard",
        regex: /^(?:5[1-5][0-9]{14})$/
      },
      {
        name: "Discover",
        abbr: "discover",
        regex: /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/
      },
      {
        name: "Diners Club",
        abbr: "diners_club",
        regex: /^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/
      },
      {
        name: "JCB",
        abbr: "jcb",
        regex: /^(?:(?:2131|1800|35\d{3})\d{11})$/
      }
    ];

    this.paymentCardInputTarget.value = currentValue.replace(/[a-zA-Z]/g, "");

    this.hiddenInputTarget.value = currentValue.replace(/[a-zA-Z\s]/g, "");

    this.formatCardNumber();

    cardTypes.forEach(c => this.paymentInputTarget.classList.remove(c.abbr));
    if (!this.valid_credit_card(number)) return;

    const cardType = cardTypes.find(cType => {
      return number.match(cType.regex);
    });
    if (cardType) this.paymentInputTarget.classList.add(cardType.abbr);
  }

  valid_credit_card(value) {
    value = value.replace(/\s/g, "");
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm.
    let nCheck = 0;
    let bEven = false;
    value = value.replace(/\D/g, "");

    for (let n = value.length - 1; n >= 0; n--) {
      const cDigit = value.charAt(n);
      let nDigit = parseInt(cDigit, 10);

      if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  }

  postCodeKeyUp(e) {
    const zval = e.target.value;
    if (zval.length > 4) this.getCityState(zval, true);
  }

  setStateAndHiddenState() {
    const {state, hiddenState} = new CheckoutStorageHandler().getData();
    if (state && hiddenState) {
      const hiddenInputState = document.querySelector('input[name="contact[state]"]');
      this.stateTarget.value = state;
      hiddenInputState.value = hiddenState;
    }
  }

  getCityState(zip, blnUSA) {
    const apiKey = "AIzaSyAhOwWugQHKt8vmYo1AHocSZ5Sp7l1lTfs";
    const date = new Date();
    const country = Cookie.getCookie("country_code");
    let lookup = `address=${encodeURI(zip)}`;
    if (country) lookup = `${lookup}&region=${country.toLowerCase()}`;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?${lookup}&key=${apiKey}&type=json&_=${date.getTime()}`;
    let city = "";
    const hascity = 0;
    const hassub = 0;
    let state = "";
    const nbhd = "";
    let subloc = "";

    Site.getRequest(url, e => {
      // find the city and state
      const response = JSON.parse(e.target.responseText);
      const address_response = response.results[0];
      if (address_response === undefined) return;
      const { address_components } = address_response;
      address_components.forEach(component => {
        const { types } = component;
        types.forEach(type => {
          if (type == "locality") {
            city = component.long_name;
            hascity = 1;
          }
          if (type == "administrative_area_level_1") {
            state = component.short_name;
          }
          if (type == "sublocality") {
            subloc = component.long_name;
            hassub = 1;
          }
        });
      });

      if (hascity == 1) {
        // do nothing
      } else if (hassub == 1) {
        city = subloc;
      } else {
        city = nbhd;
      }
      this.cityTarget.value = city;
      this.stateTarget.value = state;
      // reset
      let hascity = 0;
      let hassub = 0;
    });
  }

  scrollToRentalAgreement() {
    if (this.scrolled || !this.checkIfAllFieldsPresent()) return;
    
    this.checkboxTarget.scrollIntoView({ behavior: "smooth",block: "center" })
    this.scrolled = true;
  }

  checkIfAllFieldsPresent() {
    const form = document.querySelector('form[data-target="checkout.form"]');
    const formData = new FormData(form);
  
    const contactFields = [
      "contact[first_name]",
      "contact[last_name]",
      "contact[email]",
      "contact[phone]",
      "contact[address1]",
      "contact[country]",
      "contact[zip]",
      "contact[city]",
      "contact[state]"
    ];
  
    const paymentFields = [
      "payment[number]",
      "payment[expiration_date]",
      "payment[cvv]"
    ];

    return [...contactFields, ...paymentFields].every(field => {
      const value = formData.get(field);
      return value && value.trim();
    });
  }

  identifyWithEmail(e) {
    if (e.target.value !== '') {
      window.dataLayer.push({
        "event": "identifyWithEmail",
        "email": e.target.value
      });
    }
  }

  identifyWithPhone(e) {
    if (e.target.value !== '') {
      window.dataLayer.push({
        "event": "identifyWithPhoneNumber",
        "phoneNumber": e.target.value
      });
    }
  }
}
